import React, { useState } from 'react';
import { IconButton, TextField, Typography } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

import { useStylesPromocodeEdit } from '../hooks/useStyles';
import { IUser } from '../../../auth/interfaces';
import { DriverModal } from '../../orders/orderPage/DriverModal';

export interface IProps {
  selectedDriver: any;
  setSelectedDriver: (user?: IUser) => void;
  setChangeRange: (change: boolean) => void;
}

const FillterByUser: React.FC<IProps> = ({
  selectedDriver,
  setSelectedDriver,
  setChangeRange,
}) => {
  const [showDriverModal, setDriverModal] = useState(false);
  const classes = useStylesPromocodeEdit();

  return (
    <div className={classes.from} style={{ paddingTop: 10 }}>
      <Typography variant='h6' className={classes.title}>
        Получатель
      </Typography>

      <div className={classes.picerContainer}>
        <TextField
          type='text'
          label='Получатель'
          margin='normal'
          name='driver'
          value={`${selectedDriver?.fio ? `${selectedDriver?.fio},` : ''} ${
            selectedDriver?.phone ? `+${selectedDriver?.phone}` : ''
          }`}
          variant='outlined'
          onClick={() => setDriverModal(true)}
          InputProps={{
            readOnly: true,
            endAdornment: (
              <>
                {selectedDriver && (
                  <IconButton size='small' onClick={() => setSelectedDriver(undefined)}>
                    <ClearIcon fontSize='small' />
                  </IconButton>
                )}
              </>
            ),
          }}
        />
      </div>
      <DriverModal
        showDriverModal={showDriverModal}
        closeDriverModal={() => setDriverModal(false)}
        setFieldValue={(_fieldName: string, value: any) => {
          setSelectedDriver(value);
          setChangeRange(true);
        }}
        values={{ driver: selectedDriver }}
      />
    </div>
  );
};

export default React.memo(FillterByUser);
